import classnames from 'classnames'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import { useTrackingContext } from '../../../../../../../providers/tracking'

// Components
import Text from '../../../../../../shared/Text'
import Button from '../../../../../../shared/Button'
import PrequalAvatar from '../../PrequalAvatar'
import PrequalTabFooter from '../../PrequalTabFooter'
import { Player } from '../../../../../../shared/Player'

// Selectors
import { selectPrequalVideoId, selectPrequalVideoType } from '../../../../../../../store/selectors/videos'

// Styles
import styles from './GetPrequal.module.scss'

const propTypes = {
  customerProfileFirstName: PropTypes.string,
  customerProfilePhotoUri: PropTypes.string,
  isSponsored: PropTypes.bool,
  sponsorProfileFullName: PropTypes.string,
  sponsorPhotoUri: PropTypes.string,
  onRequest: PropTypes.func
}

const GetPrequal = ({
  customerProfileFirstName,
  customerProfilePhotoUri,
  isSponsored,
  sponsorProfileFullName,
  sponsorPhotoUri,
  onRequest
}) => {
  const videoId = useSelector(selectPrequalVideoId)
  const videoType = useSelector(selectPrequalVideoType)

  const { trackingClient } = useTrackingContext()

  return (
    <>
      <PrequalAvatar className={styles.avatar} src={customerProfilePhotoUri} />
      {isSponsored && <PrequalAvatar className={classnames(styles.cospo, styles.avatar)} src={sponsorPhotoUri} />}
      <Text paragraph variant='neutralCool' variantCount='900'>
        {isSponsored && (
          <FormattedMessage id='Affordability.noPrequal.cospo.heading' defaultMessage='Why should I get a Pre-Qual?' />
        )}
        {!isSponsored && (
          <FormattedMessage
            id='Affordability.noPrequal.directLO.heading'
            defaultMessage="You don't have a Pre-Qual yet"
          />
        )}
      </Text>
      <Text variant='neutralCool' variantCount='700' size='s'>
        <FormattedMessage
          id='Affordability.noPrequal.explain'
          defaultMessage='Why get a pre-qual? It’s a fast process that helps you better understand your true affordability and can give you better negotiation power during the buying process.'
        />
        {isSponsored && ' ' && (
          <FormattedMessage
            id='Affordability.noPrequal.cospo.explain'
            defaultMessage='{rea} speaks highly of {lo}, a lender they trust, to help answer questions and walk through different financial scenarios.'
            values={{
              rea: customerProfileFirstName,
              lo: sponsorProfileFullName
            }}
          />
        )}
      </Text>
      {Boolean(videoType && videoId) && <Player videoType={videoType} videoId={videoId} className={styles.player} />}

      <PrequalTabFooter>
        <Button
          primary
          onClick={() => onRequest(trackingClient)}
          className={styles.centerButton}
          data-qa='prequalTab.requestButton'
        >
          <FormattedMessage id='Affordability.noPrequal.request' defaultMessage='Get My Pre-Qual' />
        </Button>
      </PrequalTabFooter>
    </>
  )
}

GetPrequal.propTypes = propTypes

export default GetPrequal
